


























import Vue from "vue";

export interface CardFormResult {
  message?: string;
  cardForm?: { cardToken: string; cardSaveFlg?: boolean };
}

export default Vue.extend({
  name: "PaymentMethod",
  props: {
    /** 依頼金額 */
    amount: {
      type: Number,
    },
    systemCommission: {
      type: Number,
    },
    settlementCommission: {
      type: Number,
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  filters: {
    amountLocaleString(amount: number) {
      if (amount) {
        return amount.toLocaleString();
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
  },
});
